export enum TaskStatusGroup {
	All = 1,
	Assignable = 2,
	AssignableAndUnopened = 3,
	AssignableOnSubTask = 4,
	AssignableAndUnopenedOnProduct = 5,
	AssignableOnProductSubTask = 6,
}
